export default __webpack_public_path__ + "static/media/PPI-patio-018.30ac3dc3.jpg";